<template>
  <md-card>
    <!-- <md-card-header class="md-card-header-icon">
      <div class="card-icon">
        <md-icon>directions_car</md-icon>
      </div>
      <h4 class="title">
        Vehicle Information
      </h4>
    </md-card-header> -->
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-small-size-100">
          <validation-provider rules="doorno" ref="vehicle_door_no" v-slot="{ errors }">
          <md-field class="md-invalid">
            <label for="">Vehicle No</label>
            <md-input v-model="vehicle.vehicle_door_no" required/>
            <validation-error :errors="apiValidationErrors.vehicle_door_no" />
          <span class="md-error">{{ errors[0] }}</span>
          </md-field>
          </validation-provider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <validation-provider rules="productionyear" ref="vehicle_production_year" v-slot="{ errors }">
          <md-field class="md-invalid">
            <label for="">Production Year</label>
            <md-input type="text" v-on:keypress="NumbersOnly" v-model="vehicle.vehicle_production_year" />
            <validation-error :errors="apiValidationErrors.vehicle_production_year" />
          <span class="md-error">{{ errors[0] }}</span>
          </md-field>
          </validation-provider>
        </div>
      <!-- </div>

      <div class="md-layout"> -->
        <div class="md-layout-item  md-size-50 md-small-size-100">
          <validation-provider
            rules="policeno"
            ref="vehicle_plate_no"
            v-slot="{ errors }"
          >
            <md-field class="md-invalid">
              <label for="">Plate No</label>
              <md-input required maxlength="10" v-model="vehicle.vehicle_plate_no" onkeydown="if(['Space'].includes(arguments[0].code)){return false;}"/>
              <validation-error
                :errors="apiValidationErrors.vehicle_plate_no"
              />
            <md-avatar >
              <md-icon style="color:blue;">report</md-icon>
              <md-tooltip md-direction="left">Example : B123HD (without space)</md-tooltip>
            </md-avatar>
            <span class="md-error">{{ errors[0] }}</span>
            </md-field>
          </validation-provider>
        </div>

        <div class="md-layout-item  md-size-50 md-small-size-100">
          <validation-provider rules="platecolor" ref="vehicle_plate_color" v-slot="{ errors }">
          <md-field class="md-invalid">
            <label for="">Plate Color</label>
            <md-select v-model="vehicle.vehicle_plate_color" required>
              <md-option value="0">Kuning</md-option>
              <md-option value="1">Hitam</md-option>
            </md-select>
            <validation-error :errors="apiValidationErrors.vehicle_plate_color" />
          <span class="md-error">{{ errors[0] }}</span>
          </md-field>
          </validation-provider>
        </div>
      <!-- </div>

      <div class="md-layout"> -->
        <div class="md-layout-item md-size-50 md-small-size-100">
          <validation-provider rules="pool" ref="vehicle_pool" v-slot="{ errors }">
          <md-field class="md-invalid">
            <label>Eshed</label>
            <md-select v-model="vehicle.vehicle_pool" required>
              <md-option value="1">ICM</md-option>
              <md-option value="2">Gigashed PDC</md-option>
              <md-option value="3">ES Cikupa</md-option>
              <md-option value="4">ES Kemang</md-option>
            </md-select>
            <validation-error :errors="apiValidationErrors.vehicle_pool" />
          <span class="md-error">{{ errors[0] }}</span>
          </md-field>
          </validation-provider>
        </div>

        <div class="md-layout-item  md-size-50 md-small-size-100">
          <validation-provider rules="regisyear" ref="vehicle_registration_year" v-slot="{ errors }">
          <md-field class="md-invalid">
            <label>Registration Year</label>
            <md-input type="year" v-model="vehicle.vehicle_registration_year" required />
            <validation-error :errors="apiValidationErrors.vehicle_registration_year" />
          <span class="md-error">{{ errors[0] }}</span>
          </md-field>
          </validation-provider>
        </div>
      <!-- </div>

      <div class="md-layout"> -->
        <!-- <div class="md-layout-item md-size-50 md-small-size-100">
          <validation-provider rules="businessunit" ref="vehicle_business_unit_id" v-slot="{ errors }">
          <md-field class="md-invalid">
            <label for="">Business Unit</label>
            <md-input required v-model="vehicle_busniness_text"  readonly />
            <md-button class="md-icon-button md-info md-dense" v-on:click="findVehicleBusinessUnit">
              <md-icon >search</md-icon>
            </md-button>
            <validation-error :errors="apiValidationErrors.vehicle_business_unit_id" />
            <span class="md-error">{{ errors[0] }}</span>
          </md-field>
          </validation-provider>
        </div> -->

        <div class="md-layout-item md-size-50 md-small-size-100">
          <validation-provider v-slot="{ errors }">
          <md-field class="md-invalid">
            <label>Registration Name</label>
            <md-input type="year" v-model="vehicle.vehicle_registration_name" />
            <validation-error :errors="apiValidationErrors.vehicle_registration_name" />
          <span class="md-error">{{ errors[0] }}</span>
          </md-field>
          </validation-provider>
        </div>
      <!-- </div>

      <div class="md-layout"> -->
        <div class="md-layout-item md-size-50 md-small-size-100">
          <validation-provider rules="vehicle_type" ref="vehicle_type_id" v-slot="{ errors }">
          <md-field class="md-invalid">
            <label>Vehicle Type</label>
            <md-input v-model="vehicle_type_view" required readonly/>
            <validation-error :errors="apiValidationErrors.vehicle_type_id" />
            <md-button style="background-color:green;" class="md-icon-button md-info md-dense" v-on:click="findVehicleType">
              <md-icon >search</md-icon>
            </md-button>
          <span class="md-error">{{ errors[0] }}</span>
          </md-field>
          </validation-provider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <validation-provider rules="engineno" ref="vehicle_engine_no" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label>Engine No</label>
              <md-input v-model="vehicle.vehicle_engine_no" required/>
              <validation-error :errors="apiValidationErrors.vehicle_engine_no" />
            <span class="md-error">{{ errors[0] }}</span>
            </md-field>
          </validation-provider>
        </div>
      <!-- </div>

      <div class="md-layout"> -->
        
        <div class="md-layout-item md-size-50 md-small-size-100">
          <validation-provider rules="bodycolor" ref="vehicle_body_color" v-slot="{ errors }">
          <md-field class="md-invalid">
            <label for="">Body Color</label>
            <md-select v-model="vehicle.vehicle_body_color" required>
              <md-option value="0">Putih</md-option>
              <md-option value="1">Putih Kuning</md-option>
              <md-option value="2">Putih Metalik</md-option>
              <md-option value="3">Hitam</md-option>
              <md-option value="4">Hitam Metalik</md-option>
              <md-option value="5">Silver</md-option>
              <md-option value="6">Silver Metalik</md-option>
              <md-option value="7">Abu-Abu</md-option>
              <md-option value="8">Abu-Abu Metalik</md-option>
              <md-option value="9">Hijau</md-option>
            </md-select>
            <validation-error :errors="apiValidationErrors.vehicle_body_color" />
          <span class="md-error">{{ errors[0] }}</span>
          </md-field>
          </validation-provider>
        </div>
        
        
        <div class="md-layout-item md-size-50 md-small-size-100">
          <validation-provider rules="chassisno" ref="vehicle_chassis_no" v-slot="{ errors }">
          <md-field class="md-invalid">
            <label for="">Chassis No</label>
            <md-input v-model="vehicle.vehicle_chassis_no" required/>
            <validation-error :errors="apiValidationErrors.vehicle_chassis_no" />
          <span class="md-error">{{ errors[0] }}</span>
          </md-field>
          </validation-provider>
        </div>
        


    </div>
        
    </md-card-content>
      <modal ref="modalListVehicleType" class="coba">
                    <template v-slot:header>
                      <h3>List Vehicle</h3>
                    </template>

                    <template v-slot:body>
                      <list-vehicle-type :data_id="$refs.modalListVehicleType.data"/>
                    </template>

                    <template v-slot:footer>
                      <md-card-actions>
                        <md-button @click="modalCloseListVehicleType">
                          Close
                        </md-button>
                      </md-card-actions>
                    </template>
      </modal>
      <modal ref="modalListVehicleDriver" class="coba">
                    <template v-slot:header>
                      <h3>List Driver</h3>
                    </template>

                    <template v-slot:body>
                      <list-vehicle-driver :data_id="vehicle.vehicle_location"/>
                    </template>

                    <!-- <template v-slot:footer>
                      <md-card-actions>
                        <md-button @click="modalCloseListVehicleDriver">
                          Close
                        </md-button>
                      </md-card-actions>
                    </template> -->
      </modal>
      <modal ref="modalListVehicleBusinessUnit" class="coba">
            <template v-slot:header>
              <h3>List Business Unit</h3>
            </template>

            <template v-slot:body>
              <list-vehicle-business-unit :data_id="$refs.modalListVehicleBusinessUnit.data"/>
            </template>
          </modal>
  </md-card>
</template>
<script>
import { Modal } from "@/components";
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import ListVehicleType from "@/pages/Dashboard/Workshop/Vehicle/ComponentForm/Modal/ListVehicleType.vue";
import ListVehicleBu from "@/pages/Dashboard/Workshop/Vehicle/ComponentForm/Modal/ListVehicleBusinessUnit.vue";
import ListVehicleDriver from "@/pages/Dashboard/Workshop/Vehicle/ComponentForm/Modal/ListVehicleDriver.vue";
import Swal from "sweetalert2";
import Vue from 'vue';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
  


Vue.use(Viewer);

extend("vehicle_type", {
  ...required,
  message: "Vehicle type field is required",
});

extend("doorno", {
  ...required,
  message: "Vehicle No field is required",
});

extend("vehicle_location", {
  ...required,
  message: "Vehicle location field is required",
});
extend("productionyear", {
  ...required,
  message: "Production Year field is required",
});

extend("policeno", {
  ...required,
  message: "Police No. field is required",
});
extend("platecolor", {
  ...required,
  message: "Plate Color field is required",
});
extend("pool", {
  ...required,
  message: "Eshed field is required",
});
extend("businessunit", {
  ...required,
  message: "Business Unit field is required",
});
extend("engineno", {
  ...required,
  message: "Engine No field is required",
});
extend("chassisno", {
  ...required,
  message: "Chassis  No field is required",
});
extend("bodycolor", {
  ...required,
  message: "Body Color field is required",
});
extend("regisyear", {
  ...required,
  message: "Registration Year field is required",
});
extend("chassisno", {
  ...required,
  message: "Chassis No field is required",
});

export default {
  name: "vehicle-card",

   props: ["vehicle"],
   
  components: { ValidationError,Modal,"list-vehicle-type": ListVehicleType,"list-vehicle-driver": ListVehicleDriver, "list-vehicle-business-unit": ListVehicleBu },

  mixins: [formMixin],

  // watch: { 
  //     	vehicle: function(newVal, oldVal) { // watch it
  //       if(this.vehicle.vehicle_type.vehicle_brands && this.vehicle.vehicle_type.vehicle_brands.vehicle_brand_name){
          
  //         this.vehicle_type_view =this.vehicle.vehicle_type.vehicle_brands.vehicle_brand_name+' '+ this.vehicle.vehicle_type.vehicle_model +'-'+  this.vehicle.vehicle_type.vehicle_production_year_model
  //         this.vehicle.vehicle_type =this.vehicle.vehicle_type.id

  //       }
  //       if(this.vehicle.vehicle_location.location_category){
          
  //         this.vehicle_location_view =this.vehicle.vehicle_location.location_category.location_category_name+' '+ this.vehicle.vehicle_location.location_name
  //         this.vehicle.vehicle_location =this.vehicle.vehicle_location.id

  //       }
  //       if(this.vehicle.vehicle_driver){
          
  //         this.vehicle_driver_view =this.vehicle.vehicle_driver.driver_name
  //         this.vehicle.vehicle_driver =this.vehicle.vehicle_driver.id

  //       }
  //       }
  //     },
  data() {
    return {
      //options_model: null,
      vehicle_type_view: null,
      vehicle_location_view: null,
      vehicle_driver_view: null,
      url_file_vehicle:null,
      vehicle_busniness_text : null
    };
  },

  created() {
    this.onOpen();
  },

  methods: {
    //fungsi saat pertamakali page di buka
    async onOpen() {
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    
     
     findVehicleType(){
      this.$refs.modalListVehicleType.openModal()
    },

    findVehicleBusinessUnit(){
      this.$refs.modalListVehicleBusinessUnit.openModal()
    },

    modalCloseListVehicleBusinessUnit(data){
      console.log(data)
      if(data.id){
       this.vehicle.vehicle_business_unit_id = data.id
       this.vehicle_busniness_text = data.business_unit_name
      }
      this.$refs.modalListVehicleBusinessUnit.closeModal()
    },


    modalCloseListVehicleType(data,brand){
      console.log(data)
      if(data.id){
       this.vehicle.vehicle_type = data.id
       this.vehicle_type_view = brand+', '+ data.vehicle_model +' '+  data.vehicle_production_year_model
      }
      this.$refs.modalListVehicleType.closeModal()
    },

    getData() {
        this.$emit('data', this.vehicle)
       
    },

    async getDataParent() {
      this.vehicle_type_view = this.vehicle.vehicle_type.vehicle_brands.vehicle_brand_name+', '+ this.vehicle.vehicle_type.vehicle_model +' '+  this.vehicle.vehicle_type.vehicle_year_model
      // this.vehicle.vehicle_business_unit_id = this.vehicle.vehicle_business_unit.id
      this.vehicle_busniness_text = this.vehicle.vehicle_business_unit.business_unit_name
      this.vehicle.vehicle_type =  this.vehicle.vehicle_type.id
    },
 
    //fungsi yang di panggil dari sisi parent untuk mengechek validasi form di child ini
    async validateForm() {
      // const service_estimate_no = this.$refs['service_estimate_no'];
      const vehicle_plate_no = this.$refs['vehicle_plate_no'];
      const vehicle_production_year = this.$refs['vehicle_production_year'];
      const vehicle_door_no = this.$refs['vehicle_door_no'];
      // const vehicle_business_unit_id = this.$refs['vehicle_business_unit_id'];
      const vehicle_type_id = this.$refs['vehicle_type_id'];
      const vehicle_body_color = this.$refs['vehicle_body_color'];
      const vehicle_pool = this.$refs['vehicle_pool'];
      const vehicle_plate_color = this.$refs['vehicle_plate_color'];
      const vehicle_registration_year = this.$refs['vehicle_registration_year'];
      const vehicle_chassis_no = this.$refs['vehicle_chassis_no'];
      const vehicle_engine_no = this.$refs['vehicle_engine_no'];
      
      let result = []
        // result.push(
        //     await service_estimate_no.validate().then(function(data){
        //     return data.valid
        //     })
        // )
        result.push(
        await vehicle_production_year.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await vehicle_chassis_no.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await vehicle_engine_no.validate().then(function(data){
          return data.valid
        })
      )
        result.push(
        await vehicle_registration_year.validate().then(function(data){
          return data.valid
        })
      )
        result.push(
        await vehicle_plate_color.validate().then(function(data){
          return data.valid
        })
      )
        result.push(
        await vehicle_pool.validate().then(function(data){
          return data.valid
        })
      )
        result.push(
        await vehicle_body_color.validate().then(function(data){
          return data.valid
        })
      )
        result.push(
        await vehicle_business_unit_id.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await vehicle_type_id.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await vehicle_door_no.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await vehicle_plate_no.validate().then(function(data){
          return data.valid
        })
      )

      return result.every(Boolean)
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer {cursor: pointer;}
.photo_list{
    max-width: 100%;
    height: auto;
    display: block;
    /* margin-left: auto;
    margin-right: auto; */
}

.md-layout-item{
  margin-top:10px;
}

.coba{
  width:800px !important;
  margin: 50px auto !important;
  
  @media screen and (max-width: 992px) {
      width: 90% !important;
    }
}
</style>
